import React from 'react';

import ActionButton from '@root/Components/Buttons/ActionButton';

const ViewBookingButton = (props) => {

    if (!props.booking) {
        return;
    }

    return (
        <ActionButton
            icon="fa-eye"
            className="view-booking"
            onClick={() => {
                props.onClick();
            }}
        />
    )
}

ViewBookingButton.defaultProps = {
    onClick: () => null,
}

export default ViewBookingButton;
